import React from 'react'

import { useCanary } from '@bill/canary.react'
import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Drawer from '@divvy-web/skylab.drawer'
import Scrim from '@divvy-web/skylab.scrim'

import {
  InviteCollaboratorsDrawerView,
  LegacyInviteCollaboratorsDrawerView,
} from '@sputnik/components/InviteCollaborators/InviteCollaboratorsDrawerView'
import { InviteCollaboratorsDrawerProps } from '@sputnik/components/InviteCollaborators/types'

import styles from './styles.module.scss'

const InviteCollaboratorsDrawer = ({ isShowing, icon = 'close', ...rest }: InviteCollaboratorsDrawerProps) => {
  const [getClassName, makeTestId] = useNameFormatter('InviteCollaboratorsDrawer')

  const isInviteCollaboratorsRedesign = useCanary('rollout-invite-collaborators-redesign')

  const drawerViews = {
    default: isInviteCollaboratorsRedesign ? (
      <InviteCollaboratorsDrawerView
        icon={icon}
        isShowing={isShowing}
        {...rest}
      />
    ) : (
      <LegacyInviteCollaboratorsDrawerView
        icon={icon}
        isShowing={isShowing}
        {...rest}
      />
    ),
  }

  return (
    <Scrim isShowing={isShowing}>
      <Drawer
        activeViewKey='default'
        className={styles[getClassName('')]}
        dataTestId={makeTestId('')}
        isShowing={isShowing}
        views={drawerViews}
      />
    </Scrim>
  )
}

export default InviteCollaboratorsDrawer
